import CreationTool from '../../../types/creation-tool'
import CreationToolSourceEditor from '../../../types/source-editor'
import { CreationToolUploadSource } from '../types'

export function useAvailableEditors(source: CreationToolUploadSource, tool: CreationTool): CreationToolSourceEditor[] {
    return CreationToolSourceEditor.all().filter(editor => {
        // ignore main editor since we have an "Open Editor" item
        if (editor === CreationToolSourceEditor.Edit) {
            return false
        }

        const supportedTools = CreationToolSourceEditor.supportedCreationTools(editor)
        const supportedOutputTypes = CreationToolSourceEditor.supportedOutputTypes(editor)

        // only show available editors for the item's output type and creation tool
        return supportedTools.indexOf(tool) > -1 && supportedOutputTypes.indexOf(source.outputType) > -1
    })
}
